import { useEffect, useState } from "react";
import { db } from "../firebase";
import {
  collection,
  onSnapshot,
  orderBy,
  query,
  updateDoc,
  doc,
} from "firebase/firestore";
import { createCategory } from "../services/categoryService";

export default function Categories({ admin }) {
  const [categories, setCategories] = useState([]);
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const q = query(collection(db, "categories"), orderBy("createdAt", "desc"));
    return onSnapshot(q, (snap) =>
      setCategories(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
    );
  }, []);

  const addCategory = async () => {
    if (!name.trim()) return alert("Category name required");
    setLoading(true);
    await createCategory({ name: name.trim(), admin });
    setName("");
    setLoading(false);
  };

  const toggleStatus = async (id, isActive) => {
    await updateDoc(doc(db, "categories", id), {
      isActive: !isActive,
    });
  };

  return (
    <div className="space-y-6">

      {/* ===== HEADER ===== */}
      <div>
        <h2 className="text-xl font-semibold text-white">
          Manage Categories
        </h2>
        <p className="text-sm text-neutral-500">
          Create and control post categories
        </p>
      </div>

      {/* ===== ADD CATEGORY ===== */}
      <div className="flex gap-3 max-w-md">
        <input
          type="text"
          placeholder="New category name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="flex-1 px-4 py-2.5 rounded-lg
                     bg-neutral-950 border border-neutral-800
                     text-sm text-white placeholder-neutral-500
                     focus:outline-none focus:border-red-500/60
                     focus:ring-1 focus:ring-red-500/30 transition"
        />

        <button
          onClick={addCategory}
          disabled={loading}
          className="px-5 py-2.5 rounded-lg
                     bg-red-600 hover:bg-red-500
                     text-sm font-medium text-black
                     disabled:opacity-60 disabled:cursor-not-allowed
                     transition"
        >
          {loading ? "Adding..." : "Add"}
        </button>
      </div>

      {/* ===== TABLE ===== */}
      <div className="overflow-hidden rounded-xl border border-neutral-800">
        <table className="w-full text-sm">
          <thead className="bg-neutral-900 text-neutral-400">
            <tr>
              <th className="px-4 py-3 text-left">Name</th>
              <th className="px-4 py-3 text-left">Status</th>
              <th className="px-4 py-3 text-left">Created By</th>
              <th className="px-4 py-3 text-right">Action</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-neutral-800">
            {categories.length === 0 && (
              <tr>
                <td
                  colSpan="4"
                  className="px-4 py-6 text-center text-neutral-500"
                >
                  No categories created yet
                </td>
              </tr>
            )}

            {categories.map((c) => (
              <tr
                key={c.id}
                className="hover:bg-neutral-900/40 transition"
              >
                <td className="px-4 py-3 text-white">
                  {c.name}
                </td>

                <td className="px-4 py-3">
                  <span
                    className={`inline-flex px-3 py-1 rounded-full text-xs font-medium
                      ${
                        c.isActive
                          ? "bg-emerald-500/15 text-emerald-400"
                          : "bg-neutral-500/15 text-neutral-400"
                      }`}
                  >
                    {c.isActive ? "Active" : "Inactive"}
                  </span>
                </td>

                <td className="px-4 py-3 text-neutral-400">
                  {c.createdBy?.email || "—"}
                </td>

                <td className="px-4 py-3 text-right">
                  <button
                    onClick={() => toggleStatus(c.id, c.isActive)}
                    className={`px-4 py-1.5 rounded-md text-xs font-medium transition
                      ${
                        c.isActive
                          ? "bg-neutral-800 text-neutral-300 hover:bg-neutral-700"
                          : "bg-red-600/20 text-red-400 hover:bg-red-600/30"
                      }`}
                  >
                    {c.isActive ? "Disable" : "Enable"}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  );
}
